import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { Grid } from "semantic-ui-react";
import "../resources/CommonCompoenent.scss";
import Dropdown from "./Booking/FormComponent/Dropdown";

function SingleDateCustomCalendar(props) {
  const [day, setDateDay] = useState(props.date ? moment(props.date).format("DD") : moment().format("DD"));
  const [month, setMonth] = useState(props.date ? moment(props.date).format("MMMM") : moment().format("MMMM"));
  const [year, setYear] = useState( props.date ? moment(props.date).format("YYYY") : moment().format("YYYY"));

  const [openYearsDropDown, setOpenYearsDropdDown] = useState(false);
  const [openMonthsDropDown, setOpenMonthsDropDown] = useState(false);

  let calenderRef = useRef();
  let monthsRef = useRef();
  let yearsRef = useRef();

  useEffect(() => {
    if (props.open) {

      resetDate();
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      // scroll into view handling
      if (calenderRef.current) {
        const modalRect = calenderRef.current.getBoundingClientRect();
        if (modalRect.bottom > window.innerHeight) {
          calenderRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    } else {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
  }, [props.open]);

  useEffect(() => {
    let handler = (e) => {
      if (openMonthsDropDown) {
        if (!monthsRef.current.contains(e.target)) {
          setOpenMonthsDropDown(false);
        }
      } else if (openYearsDropDown) {
        if (!yearsRef.current.contains(e.target)) {
          setOpenYearsDropdDown(false);
        }
      } else if (props.open) {
        if (!calenderRef.current.contains(e.target)) {
          props.setOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  useEffect(() => {
    let handler = (e) => {
      if (openMonthsDropDown) {
        if (!monthsRef.current?.contains(e.target)) {
          setOpenMonthsDropDown(false);
        }
      } else if (openYearsDropDown) {
        if (!yearsRef.current?.contains(e.target)) {
          setOpenYearsDropdDown(false);
        }
      } else if (props.open) {
        if (!calenderRef.current?.contains(e.target)) {
          props.setOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  useEffect(() => {
    resetDate();
  }, [props.date]);

  const resetDate = () => {
    console.log("Called")
    if (props.date == null || props.date == undefined || props.date == "") {
      setDateDay(moment().format("DD"));
      setMonth(moment().format("MMMM"));
      setYear(moment().format("YYYY"));
    } else {
      setDateDay(moment(props.date).format("DD"));
      setMonth(moment(props.date).format("MMMM"));
      setYear(moment(props.date).format("YYYY"));
    }
  };

  const years = () => {
    let yearsArr = [];
    for (let i = props.startYear !== undefined ? props.startYear : 2016; i < parseInt(moment().format("YYYY")) + 4; i++) {
      yearsArr.push(i);
    }
    return yearsArr;
  };

  const onSelectYear = (value, type) => {
    setYear(value);
    setOpenYearsDropdDown(false);
    setDateDay(1);
  };

  const onSelectMonth = (value, type) => {
    setMonth(value);
    setOpenMonthsDropDown(false);
    setDateDay(1);
  };

  const openDropDown = (type) => {
    if (type === "year") {
      setOpenYearsDropdDown(!openYearsDropDown);
      setOpenMonthsDropDown(false);
    } else if (type === "dateMonths") {
      setOpenMonthsDropDown(!openMonthsDropDown);
      setOpenYearsDropdDown(false);
    }
  };

  const isDisableNavigation = (type) => {
    if (type === "previous") {
      if (notNullUndefined(props.restrictedPastDate)) {
        if (year == moment(props.restrictedPastDate).format("YYYY") && months.indexOf(month) == months.indexOf(moment(props.restrictedPastDate).format("MMMM"))) {
          return true;
        }
      }
    } else {
      if (notNullUndefined(props.restrictedFutureDate)) {
        if (year == moment(props.restrictedFutureDate).format("YYYY") && months.indexOf(month) == months.indexOf(moment(props.restrictedFutureDate).format("MMMM"))) {
          return true;
        }
      }
    }
    return false;
  };

  const onOpenCalender = () => {
    if (!props.isLoading) {
      resetDate();
      props.setOpen(true);
    }
  };

  const notNullUndefined = (value) => {
    return value != null && value != undefined;
  };

  const closeModal = () => {
    props.setOpen(false);
  };

  const onChangeMonth = (type) => {
    let currentStateValueIndex = months.indexOf(month);
    setDateDay(1);
    if (type === "previous") {
      if (notNullUndefined(props.restrictedPastDate)) {
        if (year == moment(props.restrictedPastDate).format("YYYY") && months.indexOf(moment(props.restrictedPastDate).format("MMMM")) == months.indexOf(month) - 1) {
          setDateDay(moment(props.restrictedPastDate).format("DD"));
        }
      } else {
        setDateDay(moment(props.restrictedPastDate).format("DD"));
      }
      if (currentStateValueIndex !== 0) {
        setMonth(months[currentStateValueIndex - 1]);
      } else {
        setMonth(months[11]);
        setYear(parseInt(year) - 1);
      }
    } else {
      if (currentStateValueIndex !== 11) {
        setMonth(months[currentStateValueIndex + 1]);
      } else {
        setMonth(months[0]);
        setYear(parseInt(year) + 1);
      }
    }
  };

  const isDisableDate = (date) => {
    const dateToCheck = `${date}/${month}/${year}`;
    if (props.restrictedFutureDate != undefined && props.restrictedPastDate != undefined) {
      return !(moment(dateToCheck).isBefore(moment(props.restrictedFutureDate)) && !moment(dateToCheck).isBefore(moment(props.restrictedPastDate)));
    } else {
      if (props.restrictedFutureDate) {
        return !moment(dateToCheck).isBefore(moment(props.restrictedFutureDate));
      }
      if (props.restrictedPastDate) {
        return moment(dateToCheck).isBefore(moment(props.restrictedPastDate));
      }
    }
    return false;
  };

  const generateDates = () => {
    let startDayOfMonth = moment(`${year}-${month}-01`).format("dddd");

    let startDayOfMonthValue = null;
    let endOfTheMonth = parseInt(moment(`${year}-${month}-01`).endOf("month").format("DD"));

    const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    for (let i = 1; i < weekdays.length; i++) {
      if (startDayOfMonth == weekdays[i]) {
        startDayOfMonthValue = i;
      }
    }

    let daysLayout = [];
    for (let i = 0; i < 42; i++) {
      if (i >= startDayOfMonthValue) {
        if (endOfTheMonth >= i - startDayOfMonthValue + 1) {
          daysLayout.push(
            <div onClick={() => (isDisableDate(i - startDayOfMonthValue + 1) ? null : onSelectDate(i - startDayOfMonthValue + 1))} tabIndex='0' className={`days ${isDisableDate(i - startDayOfMonthValue + 1) ? "disabled" : day == i - startDayOfMonthValue + 1 ? "selected" : ""}`}>
              {i - startDayOfMonthValue + 1}
            </div>
          );
        }
      } else {
        daysLayout.push(<div className='days no_dates'></div>);
      }
    }

    return daysLayout;
  };

  const onSelectDate = (date) => {
    setDateDay(date);
    props.setDate(moment(`${year}-${months.indexOf(month) < 9 ? `0${months.indexOf(month) + 1}` : months.indexOf(month) + 1}-${date < 10 ? `0${date}` : date}`).format("YYYY-MM-DD"));
    props.setOpen(false);
  };

  return (
    <div className='single_date_calendar_container'>
      {props.open ? <div className='modalView' onClick={() => closeModal()} /> : null}

      {props.header || (
        <div className={`calendar_default_button ${props.isDisable ? "disabled" : ""}`} onClick={() => (props.isLoading || props.isDisable ? null : onOpenCalender())}>
          <h3 className={props.date === null || props.date === undefined || props.date === "" ? "placeholder_text" : ""}>{props.date === null || props.date === undefined || props.date === "" ? "Select Date" : `${moment(props.date).format(props.format || "Do MMM YYYY")}`}</h3>
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "start" }}>
        {props.open ? (
          <div ref={calenderRef} className='dates_container' style={{ position: props.position }}>
            {props.title && <div className='title_container'>{props.title}</div>}
            <div className='top_navigation'>
              <svg width='0.938rem' height='1.125rem' viewBox='0 0 15 25' fill='none' xmlns='http://www.w3.org/2000/svg' onClick={() => (isDisableNavigation("previous") ? null : onChangeMonth("previous"))}>
                <path d='M12.5 2.66669L2.84886 12.3178C2.38402 12.7827 2.39483 13.5396 2.87276 13.991L12.5 23.0834' stroke={isDisableNavigation("previous") ? "#818181" : "#303030"} strokeWidth='3.5' strokeLinecap='round' />
              </svg>

              <Dropdown
                open={openYearsDropDown}
                setOpen={() => openDropDown("year")}
                value={year}
                options={years().map((year) => {
                  return { key: year, value: year, text: year };
                })}
                style={{ width: "50%" }}
                onChange={(opt) => onSelectYear(opt.value)}
              />
              <Dropdown
                open={openMonthsDropDown}
                setOpen={() => openDropDown("dateMonths")}
                value={month}
                style={{ width: "50%" }}
                options={months.map((month) => {
                  return { key: month, value: month, text: month };
                })}
                onChange={(opt) => onSelectMonth(opt.value)}
              />

              <svg width='0.938rem' height='1.125rem' viewBox='0 0 15 25' fill='none' xmlns='http://www.w3.org/2000/svg' onClick={() => (isDisableNavigation("next") ? null : onChangeMonth("next"))}>
                <path d='M2.66602 2.16663L12.3172 11.8178C12.782 12.2826 12.7712 13.0395 12.2933 13.4909L2.66602 22.5833' stroke={isDisableNavigation("next") ? "#818181" : "#303030"} strokeWidth='3.5' strokeLinecap='round' />
              </svg>
            </div>

            <div className='days_date_view'>
              {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((day, index) => (
                <p className='week_label'>{day}</p>
              ))}
              {generateDates()}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default SingleDateCustomCalendar;
